import { PointType } from './pointtype.enum';
import { TerritoryType } from './territorytype.enum';
import { ILocation, Location } from './location';
import { IGPSLocation, GPSLocation } from './gpslocation';
import { IDispatchPoint, DispatchPoint } from './dispatchpoint';

export class AuthorityPoint {

    type: PointType;
    displayName: string;
    dispatchPoint: DispatchPoint;
    dispatchablePoint: string;
    location: Location;
    gps: GPSLocation;
    territoryType: TerritoryType;
    
    constructor(authorityPoint: IAuthorityPoint) {

        this.type = authorityPoint.type;
        this.displayName = authorityPoint.displayName;
        this.dispatchPoint = authorityPoint.dispatchPoint === undefined ? undefined : new DispatchPoint(authorityPoint.dispatchPoint);
        this.dispatchablePoint = authorityPoint.dispatchablePoint;
        this.location = new Location(authorityPoint.location);
        this.gps = authorityPoint.gps === undefined ? undefined : new GPSLocation(authorityPoint.gps);
        this.territoryType = authorityPoint.territoryType;
    }

    static clone(source:AuthorityPoint, destination?:AuthorityPoint): AuthorityPoint {
        if(destination === undefined) {
            destination = {} as AuthorityPoint;
        }
        for(let key in source) {
            if(key === 'clone' || key === '_$visited') {
                continue;
            }
            destination[key] = {};
            if(source[key] === Object(source[key]) && !(source[key] instanceof String)) {
                this.clone(source[key], destination[key]);
            } else {
                if (typeof source[key] === 'string' || source[key] instanceof String) {
                    let sourceStringVal:string = source[key];
                    destination[key] = sourceStringVal.toUpperCase();
                } else {
                    destination[key] = source[key];
                }
            }
        }
        return destination;
    }
}

export interface IAuthorityPoint {

    type: PointType;
    displayName: string;
    dispatchPoint: IDispatchPoint;
    dispatchablePoint: string;
    location: ILocation;
    gps: IGPSLocation;
    territoryType: TerritoryType;
    label?: string;
}